<template>
  <div>
    <Head @langChange="langSelect" />
    <Banner :BnnerSlides="BnnerSlide" />
    <div class="titWarp cl">
      <div class="name z">
        <span class="z">{{ $t("title.gname") }}</span>
        <i class="z">GAMES</i>
      </div>
      <div class="all y">
        <router-link :to="{ path: '/game', query: { language: lang } }">
          <i class="iconfont iconiconjia"></i>
          <span>{{ $t("title.gmore") }}</span>
        </router-link>
      </div>
    </div>
    <Games ref="game" :GameList="GameSlides" />
    <div class="titWarp cl">
      <div class="name z">
        <span class="z">{{ $t("title.nname") }}</span>
        <i class="z">NEWS</i>
      </div>
      <div class="all y">
        <router-link :to="{ path: '/News', query: { language: lang } }">
          <i class="iconfont iconiconjia"></i>
          <span>{{ $t("title.nmore") }}</span>
        </router-link>
      </div>
    </div>
    <NewsItem ref="news" :newsList="NewSlides" />
    <!-- 底部加入我们 -->
    <section class="footbgwarp">
      <div class="footbg">
        <div class="main">
          <p>{{ $t("header_menu.Join") }}</p>
          <!-- <a href="javascript:;">了解更多</a> -->
          <router-link
            class="haClass"
            v-if="lang != 'zh'"
            :to="{ path: '/join', query: { language: lang } }"
          >
            Learn more
          </router-link>
          <a
            href="https://app.mokahr.com/apply/playcrab/24831#/?anchorName=default_banner&sourceToken="
            target="blank_"
            class="haClass"
            v-else-if="lang == 'zh'"
            >了解更多</a
          >
        </div>
      </div>
    </section>
    <!-- 底部footer -->
    <Foot ref="foot"></Foot>
  </div>
</template>

<script>
import Head from "@/components/head.vue";
import Banner from "@/components/Banner.vue";
import Games from "@/components/Games.vue";
import NewsItem from "@/components/NewsItem.vue";
import Foot from "@/components/Foot.vue";
import { getIndex } from "@/common/api.js";
export default {
  name: "Home",
  components: { Head, Banner, Games, NewsItem, Foot, getIndex },

  data() {
    return {
      lang: this.$route.query.language || "zh",
      BnnerSlide: [],
      GameSlides: [],
      NewSlides: [],
      newShow: true,
    };
  },
  created() {
    //外文隐藏新闻
    if (this.lang != "zh") {
      this.newShow = false;
    } else {
      this.newShow = true;
    }
  },
  mounted() {},
  beforeMount() {
    // 在页面挂载前就发起请求
    this.getIndexs();
  },
  mounted() {},
  methods: {
    getIndexs() {
      let that = this;
      getIndex({
        language: that.lang,
      }).then((res) => {
        if (res.status == 200) {
          let Data = res.data.data;
          that.BnnerSlide = Data.BnnerSlides;
          that.GameSlides = Data.GameSlides;
          that.NewSlides = Data.NewSlides;
        } else {
          console.log(res.statusText);
        }
      });
    },
    langSelect: function (param) {
      this.lang = param;
      //外文隐藏新闻
      if (this.lang != "zh") {
        this.newShow = false;
      } else {
        this.newShow = true;
      }
      this.getIndexs();
      this.$refs.foot.langSelect(this.lang);
    },
  },
  computed: {
    // ...mapState({
    //   lang: (state) => state.lang,
    // }),
  },
};
</script>
<style scoped>
.footbgwarp {
  margin-top: 80px;
  width: 100%;
  height: 400px;
  overflow: hidden;
  background: #131313;
}
.footbg {
  height: 400px;
  background: url("../assets/images/fotbg.png") no-repeat top center;
  position: relative;
}
</style>





































































// WEBPACK FOOTER //
// src/views/index.vue